/**
 * 구독 요금 표시 — 정가 · 할인 · 실제 금액 (2026-10-28 대표 지시)
 *
 * "지금 구독 알림 뜨는 분들도 50만원에서 프로모션 적용 금액 30만원으로 표기."
 * 금액은 서버(GET subscription-consent / subscription-request 의 price)가 매장별로 계산한다 —
 * 화면에서 다시 계산하지 말 것(backend/domains/billing/services/subscription_pricing.py).
 */
import React from 'react';

export interface SubscriptionPrice {
  list_price: number;
  discount_amount: number;
  discount_label: string | null;
  monthly_fee: number;
  fee_label: string;
  list_fee_label: string;
}

const won = (n: number) => `${n.toLocaleString('ko-KR')}원`;

/** 할인이 있으면 '정가 월 500,000원 → 수강생 프로모션 적용' + 큰 글씨 실제 금액 */
export const SubscriptionPriceBlock: React.FC<{ planName: string; price?: SubscriptionPrice | null; feeLabel: string }> = ({
  planName,
  price,
  feeLabel,
}) => {
  if (!price || !price.discount_amount) {
    return (
      <p className="text-xl font-bold text-gray-900 mt-1">
        {planName} {price?.fee_label || feeLabel}
      </p>
    );
  }
  return (
    <div className="mt-1">
      <p className="text-sm text-gray-600">
        정가 <span className="line-through">월 {won(price.list_price)}</span> →{' '}
        <span className="font-semibold text-rose-700">{price.discount_label || '할인'} 적용</span>
        <span className="ml-1 text-rose-700">(−{won(price.discount_amount)})</span>
      </p>
      <p className="text-xl font-bold text-gray-900">
        {planName} {price.fee_label}
      </p>
    </div>
  );
};

/** 동의 문구 등 한 줄용: '월 300,000원(부가세 별도) — 정가 월 500,000원에 수강생 프로모션 적용' */
export const priceOneLine = (price: SubscriptionPrice | null | undefined, feeLabel: string) =>
  price && price.discount_amount
    ? `${price.fee_label} — 정가 월 ${won(price.list_price)}에 ${price.discount_label || '할인'} 적용`
    : price?.fee_label || feeLabel;
